// @ts-check
// coarse-pointer.ts — shared "is this a touch / coarse-pointer device?" probe.
//
// A single evaluated-once MediaQueryList for `(pointer: coarse)`, with a
// `{ matches: false }` fallback for hosts without `matchMedia` (or no `window`).
// Consolidates the identical guard that was inlined in ui/mobile-swipe,
// ui/resizable-panel and ui/touch-ux.
//
// NOTE: core/app-state.ts keeps its OWN probe — it force-returns a no-op
// (matches:false) MediaQueryList on Electron, so its semantics differ.

export const coarsePointerQuery: Pick<MediaQueryList, 'matches'> =
  typeof window !== 'undefined' && typeof window.matchMedia === 'function'
    ? window.matchMedia('(pointer: coarse)')
    : { matches: false };
